import React from "react";

const base = "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border";

const styles = {
  account_status: {
    Active: "bg-emerald-50 text-emerald-700 border-emerald-200",
    Inactive: "bg-sand/60 text-warm-dark/70 border-sand",
    Suspended: "bg-orange-50 text-orange-700 border-orange-200",
  },
  contract_type: {
    CDI: "bg-blue-50 text-blue-700 border-blue-200",
    CDD: "bg-violet-50 text-violet-700 border-violet-200",
    Stage: "bg-teal-50 text-teal-700 border-teal-200",
    Alternance: "bg-cyan-50 text-cyan-700 border-cyan-200",
    Freelance: "bg-pink-50 text-pink-700 border-pink-200",
  },
  presence_state: {
    Present: "bg-emerald-50 text-emerald-700 border-emerald-200",
    Remote: "bg-indigo-50 text-indigo-700 border-indigo-200",
    Leave: "bg-amber-50 text-amber-700 border-amber-200",
    Offboarding: "bg-red-50 text-red-700 border-red-200",
  },
  time_type: {
    FullTime: "bg-sand/60 text-warm-dark/70 border-sand",
    PartTime: "bg-cream text-warm-dark/60 border-sand",
  },
};

export default function StatusBadge({ kind, value }) {
  if (!value) return <span className="text-warm-dark/40 text-xs">—</span>;
  const cls = styles[kind]?.[value] || "bg-sand/60 text-warm-dark/70 border-sand";
  return (
    <span className={`${base} ${cls}`} data-testid={`badge-${kind}-${value}`}>
      {value}
    </span>
  );
}
